// extracted by mini-css-extract-plugin
export default {"tab":"Tab-module__tab--MnZJd","content":"Tab-module__content--hUw5F","highlight":"Tab-module__highlight--rMX6U"};